import actions from './actions';

const initState = {
  isCreating: false,
  isSearching: false,
  isUpdating: false,
  isDeleting: false,
};

export default function reducer(state = initState, action) {
  switch (action.type) {
    case actions.CREATE_TAG:
    case actions.ADD_MEMBER_LIST_TO_TAG_MEMBER_LIST:
    case actions.ADD_MEMBER_TO_TAG_MEMBER_LIST:
      return {
        ...state,
        isCreating: true,
      };
    case actions.CREATE_TAG_ENDED:
    case actions.ADD_MEMBER_LIST_TO_TAG_MEMBER_LIST_ENDED:
    case actions.ADD_MEMBER_TO_TAG_MEMBER_LIST_ENDED:
      return {
        ...state,
        isCreating: false,
      };
    case actions.UPDATE_TAG:
      return {
        ...state,
        isUpdating: true,
      };
    case actions.UPDATE_TAG_ENDED:
      return {
        ...state,
        isUpdating: false,
      };
    case actions.SEARCH_TAGS:
    case actions.SEARCH_TAG_MEMBER_LIST_BATCH_ROW:
    case actions.SEARCH_INVALID_TAG_MEMBER_LIST_BATCH_ROW:
      return {
        ...state,
        isSearching: true,
      };
    case actions.SEARCH_TAGS_ENDED:
    case actions.SEARCH_TAG_MEMBER_LIST_BATCH_ROW_ENDED:
    case actions.SEARCH_INVALID_TAG_MEMBER_LIST_BATCH_ROW_ENDED:
      return {
        ...state,
        isSearching: false,
      };
    case actions.DELETE_TAGS:
    case actions.DELETE_MEMBERS_FROM_MEMBER_LIST:
    case actions.DELETE_TAG_MEMBER_LIST_BATCH_ROWS:
      return {
        ...state,
        isDeleting: true,
      };
    case actions.DELETE_TAGS_ENDED:
    case actions.DELETE_MEMBERS_FROM_MEMBER_LIST_ENDED:
    case actions.DELETE_TAG_MEMBER_LIST_BATCH_ROWS_ENDED:
      return {
        ...state,
        isDeleting: false,
      };
    default:
      return state;
  }
}
